import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const PUBLIC_ADMIN_PAGES = ["login"];

const OP_PAGES = ["articles", "projects", "interns-volunteers"];

function isAdminPage(pathname: string) {
  return pathname.startsWith("/admin");
}

function getAdminPage(pathname: string) {
  if (pathname === "/admin") return "dashboard";
  const match = pathname.match(/^\/admin\/([^\/]+)/);
  return match ? match[1] : "";
}

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;

    const isAdmin = isAdminPage(location.pathname);
    const page = getAdminPage(location.pathname);
    const isPublic = PUBLIC_ADMIN_PAGES.includes(page);

    if (isAdmin && !isPublic && !user) {
      navigate("/admin/login", { replace: true });
      return;
    }

    if (isAdmin && !isPublic && user) {
      if (user.role === "superadmin" || user.role === "administrator") {
        return;
      }
      if (user.role === "operation_manager" && !OP_PAGES.includes(page)) {
        navigate("/admin/articles", { replace: true });
      }
    }
  }, [user, loading, location.pathname, navigate]);

  return <>{children}</>;
}